export default "__VITE_ASSET__CSSf3Ayj__"